import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';
import { Breadcrumbs } from '../modules/shared/components';
import { Header, Sidebar } from '../navigation';

export default function RootLayout() {
  return (
    <Stack direction='row'>
      <Header />
      <Sidebar />
      <Stack
        direction='column'
        flex={1}
        gap={8}
        sx={{
          marginTop: 'var(--header-height)',
          padding: '40px 40px 64px',
          marginLeft: 'var(--sidebar-width)',
          maxWidth: 'calc(100% - var(--sidebar-width))',
        }}
      >
        <Breadcrumbs />
        <Outlet />
      </Stack>
    </Stack>
  );
}
